var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-class"},[_c('v-tabs',{attrs:{"color":"black","dark":"","slider-color":"primary"}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Utilisateurs")])],1),_vm._v(" "),_c('user-list',{ref:"userList",attrs:{"url":'users?filter=bots.bot:$eq:'+_vm.$route.params.botId,"list-actions":_vm.importUsers}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-652fa3d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/users/user.list.vue
// module id = null
// module chunks = 